import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';
import i18n from '@/bundles/Localization';
import { LocalizationEnum } from '@/bundles/Localization/enum/LocalizationEnum';
import { getSiteDetails } from '@/bundles/Property/helpers/siteDetailsHelper';
import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';

export const getPropertySiteFiltersConfig = (): IFilterConfigItem[] => [
  {
    title: 'Property Land Size',
    name: 'property_land_size',
    type: FilterTypeEnum.land_size_range, // sending with property_land_size_unit
    category: FilterCategoryEnum.site,
  },
  {
    title: 'Net Developable Land Size',
    name: 'property_net_dev_land_size', // NEW
    type: FilterTypeEnum.land_size_range, // sending with property_net_dev_land_size_unit
    category: FilterCategoryEnum.site,
  },
  {
    title: 'Lot Dimension - Width',
    name: 'property_lot_dimension_width', // NEW
    type: FilterTypeEnum.building_dimension_range,
    category: FilterCategoryEnum.site,
  },
  {
    title: 'Lot Dimensions - Depth',
    name: 'property_lot_dimension_depth', // NEW
    type: FilterTypeEnum.building_dimension_range,
    category: FilterCategoryEnum.site,
  },
  {
    title: `Property ${i18n.t(LocalizationEnum.apn_number)}`,
    name: 'property_apn_number', // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.site,
  },
  {
    title: 'Zoning',
    name: 'property_zoning', // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.site,
  },
  {
    title: 'Access',
    name: 'property_access', // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.site,
  },
  {
    title: 'Visibility',
    name: 'property_visibility', // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.site,
  },
  {
    title: 'Flood Plain',
    name: 'property_flood_plain', // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.site,
  },
  {
    title: 'Frontage',
    name: 'property_frontage', // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.site,
  },
  {
    title: 'Frontage Traffic Count',
    name: 'property_frontage_traffic_count', // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.site,
  },
  {
    title: 'Outside Storage Yard',
    name: 'property_outside_storage', // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.site,
  },
  {
    title: 'Anchors',
    name: 'property_anchors', // NEW
    type: FilterTypeEnum.company_multiple_select,
    category: FilterCategoryEnum.site,
  },
  {
    title: 'Topography',
    name: 'property_topography', // NEW
    items: getSiteDetails().topography_type,
    type: FilterTypeEnum.autocomplete_multiple_select,
    category: FilterCategoryEnum.site,
  },
  {
    title: 'Land Condition',
    name: 'property_land_condition', // NEW
    items: getSiteDetails().condition_type,
    type: FilterTypeEnum.autocomplete_multiple_select,
    category: FilterCategoryEnum.site,
  },
  {
    title: 'FIPS Muni Code',
    name: 'property_fips_muni', // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.site,
  },
  {
    title: 'FIPS State Code',
    name: 'property_fips_state', // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.site,
  },
  {
    title: 'Block #',
    name: 'property_block', // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.site,
  },
  {
    title: 'Census',
    name: 'property_census', // NEW
    type: FilterTypeEnum.textfield,
    category: FilterCategoryEnum.site,
  }
];
